import { ModalContent } from '@/components/Modal'
import { useOnCancel } from '../../ContextProvider'
import { Body } from './Body'
import { Header } from './Header'
import { Footer } from './Footer'

export function ConfirmDiscardChanges() {
  const onCancel = useOnCancel()

  return (
    <ModalContent customCloseModal={onCancel} header={<Header />} footer={<Footer />}>
      <Body />
    </ModalContent>
  )
}
